<template>
    <calendar/>
</template>
<script>
import calendar from '@/components/fullCalendario'

export default {
    name: 'VistaRutas',
    components:{
        calendar
    } 
}
</script>